<template>
    <div class="card">
        <div class="card-header bg-white">
            <h5 class="me-auto">Listado</h5>
        </div>
        <div class="card-body p-0">
            <template>
                <v-data-table  class="elevation-1"
                    :headers="headers"
                    :items="loading == 'table' ? [] :items.data"
                    show-expand
                    :single-expand="true"
                    :expanded.sync="expanded"
                    :options.sync="options"
                    :server-items-length="items.subtotal"
                    :loading="loading == 'table'"
                    :footer-props="{
                        'items-per-page-options': [5, 10, 50, 100]
                    }">
                    <template v-slot:[`item.id`]="{ item }">
                        {{
                            items.to >= 10 ? items.to - options.itemsPerPage + items.data.indexOf(item) +
                                1 : items.data.indexOf(item) + 1
                        }}
                    </template>
                    <template v-slot:[`item.id`]="{ item }">
                        {{ item.type }}{{ item.id }}
                    </template>
                    <template v-slot:[`item.tax`]="{ item }">
                        <search-tax v-model="item.tax_id" :tax="item.tax" :childclass="'w-200px'"/>
                    </template>
                    <template v-slot:[`item.user`]="{ item }">
                        <search-user v-model="item.user" @set_value="e => item.user_id = e" :childclass="'w-200px'"/>
                    </template>
                    <template v-slot:[`item.value`]="{ item }">
                        <input type="text" v-model="item.value" class="form-control form-control-sm w-80px" placeholder="0.00" @keypress="DOUBLE">
                    </template>
                    <template v-slot:[`item.weight`]="{ item }">
                        {{ Number(String(item.weight)).toFixed(2) }}
                    </template>
                    <template v-slot:[`item.subtotal`]="{ item }">
                        {{ item.subtotal ? Number(item.subtotal).toFixed(2) : '0.00' }}
                    </template>
                    <template v-slot:[`item.calculate`]="{ item, index }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <button @click="CALCULATE(item)"
                                    type="button" v-bind="attrs" v-on="on"
                                    class="btn btn-primary btn-m" :disabled="!item.value || !item.tax_id">
                                    <small><i class="bi bi-calculator"></i></small>
                                </button>
                            </template>
                            <small>Calcular</small>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.confirm`]="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <button @click="CONFIRM(item)"
                                    :disabled="!item.subtotal" type="button" v-bind="attrs" v-on="on"
                                    class="btn btn-success btn-h w-80px">
                                    <span><i class="fa fa-save"></i> +<i class="bi bi-check-lg"></i></span>
                                </button>
                            </template>
                            <small>Confirmar</small>
                        </v-tooltip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item, index }">
                        <td colspan="100%">
                            <div class="container py-4">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group mb-2">
                                            <small class="input-title">Impuesto</small>
                                            <search-tax v-model="item.tax_id" :tax="item.tax"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group mb-2">
                                            <small class="input-title">Cliente</small>
                                            <search-user v-model="item.user" @set_value="e => item.user_id = e"/>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group mb-2">
                                            <small class="input-title">Valor</small>
                                            <div class="input-group input-group-sm mb-2">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                                                </div>
                                                <input type="text" v-model="item.value" class="form-control form-control-sm" placeholder="0.00" @keypress="DOUBLE">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group mb-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="CALCULATE(item)"
                                                        type="button" v-bind="attrs" v-on="on"
                                                        class="btn btn-primary btn-h w-100" :disabled="!item.value || !item.tax_id">
                                                        <small><i class="bi bi-calculator"></i></small>
                                                    </button>
                                                </template>
                                                <small>Calcular</small>
                                            </v-tooltip>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group mb-3">
                                            <small class="input-title">Precio</small>
                                            <div class="input-group input-group-sm mb-2">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                                                </div>
                                                <input type="text" v-model="item.subtotal" class="form-control form-control-sm" placeholder="0.00" @keypress="DOUBLE">
                                                <div class="input-group-append">
                                                    <button type="button" class="btn btn-success btn-m" @click="ADD_LINE(item)">
                                                        <i class="bi bi-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="row mb-2" v-for="(bill, i) in item.invoice_items" :key="i">
                                                <div class="input-group input-group-sm col pl-0">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                                                    </div>
                                                    <input type="text" v-model="bill.value" class="form-control form-control-sm" placeholder="0.00" @keypress="DOUBLE">
                                                </div>
                                                <div class="input-group input-group-sm col pr-0">
                                                    <input type="text" v-model="bill.description" class="form-control form-control-sm" placeholder="Descripción">
                                                    <div class="input-group-append">
                                                        <button type="button" class="btn btn-danger btn-m" @click="REMOVE(item, i)">
                                                            <i class="bi bi-x"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group mb-2">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="CONFIRM(item)"
                                                        :disabled="!item.subtotal" type="button" v-bind="attrs" v-on="on"
                                                        class="btn btn-success btn-h w-100">
                                                        <span><i class="fa fa-save"></i>+ <i class="bi bi-check-lg"></i></span>
                                                    </button>
                                                </template>
                                                <small>Confirmar</small>
                                            </v-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </template>
                </v-data-table>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    props: ['items', 'loading', 'calculate', 'confirm'],
    data(){
        return{
            headers: [
                { text: 'GVT', value: 'id', sortable: false },
                { text: 'Impuesto', value: 'tax', sortable: false },
                { text: 'Cliente', value: 'user', sortable: false },
                { text: 'Valor', value: 'value', sortable: false },
                { text: 'Peso', value: 'weight', sortable: false },
                { text: 'Total', value: 'subtotal', sortable: false },
                { text: 'Calcular', value: 'calculate', sortable: false },
                { text: 'Confirmar', value: 'confirm', sortable: false },
                { text: 'Más', value: 'data-table-expand', sortable: false }
            ],
            expanded: [],
            options: {},
            count: 0,
        }
    },
    methods: {
        CALCULATE: function(item){
            this.$emit('calculate', item)
        },
        ADD_LINE: function(item){
            this.$emit('add_line', item)
        },
        REMOVE: function(item, index){
            this.$emit('remove_line', item, index)
        },
        CONFIRM: function(item){
            this.$emit('confirm', item)
        }
    },
    watch: {
        options: {
            handler(e) {
                this.$emit('options', e)
            },
            deep: true
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/packages/table/list-view.vue